import axios from 'axios';

// Multiple keys to rotate on rate limit
const API_KEYS = [
  'c8dea14dc917687ac631a52620e4f7ad',
  '3cb41ecea3bf606c56552db3d17adefd',
];

const BASE = 'https://api.themoviedb.org/3';
export const IMG = 'https://image.tmdb.org/t/p/original';
export const IMG_W500 = 'https://image.tmdb.org/t/p/w500';

let keyIndex = 0;

async function get(path, params = {}) {
  for (let attempt = 0; attempt < API_KEYS.length; attempt++) {
    const api_key = API_KEYS[(keyIndex + attempt) % API_KEYS.length];
    try {
      const res = await axios.get(`${BASE}${path}`, {
        params: { api_key, language: 'en-US', ...params },
      });
      return res.data;
    } catch (e) {
      if (e?.response?.status === 429 || e?.response?.status === 401) {
        keyIndex = (keyIndex + 1) % API_KEYS.length;
        continue;
      }
      throw e;
    }
  }
  return null;
}

export const tmdb = {
  trending: () => get('/trending/all/week'),
  netflixOriginals: () => get('/discover/tv', { with_networks: 213 }),
  topRated: () => get('/movie/top_rated'),
  actionMovies: () => get('/discover/movie', { with_genres: 28 }),
  comedyMovies: () => get('/discover/movie', { with_genres: 35 }),
  horrorMovies: () => get('/discover/movie', { with_genres: 27 }),
  romanceMovies: () => get('/discover/movie', { with_genres: 10749 }),
  documentaries: () => get('/discover/movie', { with_genres: 99 }),
  popularTv: () => get('/tv/popular'),
  search: (query) => get('/search/multi', { query, include_adult: false }),
  // Fetch a YouTube trailer key for a given item
  videos: async (item) => {
    const type = item.media_type === 'tv' || item.first_air_date ? 'tv' : 'movie';
    const data = await get(`/${type}/${item.id}/videos`);
    if (!data || !data.results) return null;
    const trailer =
      data.results.find((v) => v.type === 'Trailer' && v.site === 'YouTube') ||
      data.results.find((v) => v.site === 'YouTube');
    return trailer ? trailer.key : null;
  },
};

export function titleOf(item) {
  return item.title || item.name || item.original_title || item.original_name || 'Untitled';
}